export var OpenBalanceTexts;
(function (OpenBalanceTexts) {
    OpenBalanceTexts["ALREADY_PAID"] = "This order's balance has already been paid in full.";
    OpenBalanceTexts["CANCEL"] = "Cancel";
    OpenBalanceTexts["CONFIRM_PAYMENT"] = "Confirm Payment";
    OpenBalanceTexts["DEFAULT_PAST_CUTOFF"] = "This order is past the cutoff date for payment. Please contact support for assistance.";
    OpenBalanceTexts["ERROR_MESSAGE"] = "There was an error loading your balance. Please try again or call support.";
    OpenBalanceTexts["ERROR_TITLE"] = "Sorry, something went wrong.";
    OpenBalanceTexts["FAILURE_TOAST"] = "An error occurred while processing your payment. Please try again or call support.";
    OpenBalanceTexts["LOADING"] = "Loading Payment Information...";
    OpenBalanceTexts["MISSING_ORDER_NUMBER"] = "Missing order number.";
    OpenBalanceTexts["NAVIGATION_PROMPT_MESSAGE"] = "Are you sure you want to leave this page without completing your payment?";
    OpenBalanceTexts["ONE_SECOND"] = "1 second";
    OpenBalanceTexts["OR_NAV"] = "You can now close the window or navigate away at any time.";
    OpenBalanceTexts["ORDER_ID"] = "Order ID";
    OpenBalanceTexts["ORDER_NOT_FOUND_MESSAGE"] = "We could not find an order with the provided link. Please try again or call support.";
    OpenBalanceTexts["ORDER_NOT_FOUND_TITLE"] = "Order Not Found";
    OpenBalanceTexts["ORDER_NUMBER"] = "Order Number";
    OpenBalanceTexts["PAGE_TITLE"] = "Payment Due";
    OpenBalanceTexts["PAYMENT_COMPLETE"] = "Payment Complete!";
    OpenBalanceTexts["PAYMENT_ERROR"] = "An error occurred while processing the payment. Please try again or call support.";
    OpenBalanceTexts["PAYMENT_FAILED"] = "Payment failed. Please try again or call support.";
    OpenBalanceTexts["REDIRECTING"] = "You will be redirected to your orders page in {countdown}...";
    OpenBalanceTexts["REMAINING_BALANCE"] = "Remaining Balance";
    OpenBalanceTexts["SECONDS"] = "seconds";
    OpenBalanceTexts["SUCCESS_TOAST"] = "Your payment was successfully processed!";
    OpenBalanceTexts["VIEW_INVOICE"] = "View Invoice";
})(OpenBalanceTexts || (OpenBalanceTexts = {}));
